import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom';
import CookieConsent from 'react-cookie-consent';
import ManagePermissions from 'components/notifications/ManagePermissions';

import 'style/components/notification/cookie-banner.scss';

class CookieBanner extends Component {

    static propTypes = {
        message:         PropTypes.string, // String with the message
        acceptMessage:   PropTypes.string, // Button text
        moreInformation: PropTypes.string // More information text
    };


    state = {
        isManagePermissonsOpen: false,
        googleAnalytics:        true,
        mandatoryCookies:       true
    };

    /**
     * Set this to handlers
     */
    componentWillMount() {
        this.handleOnAccept = this.handleOnAccept.bind(this);
    }

    /**
     * Prevent default also bubble onToggle event
     * @param {Event} e The event object
     */
    handleOnAccept(e) {
        e && e.preventDefault();
        const { onAccept } = this.props;

        onAccept && onAccept();
    }

    render() {
        const {message, acceptMessage, moreInformation, intl: {formatMessage}} = this.props;

        return <div className={'cookie-consent'}>
            <CookieConsent
                location="bottom"
                buttonText={acceptMessage}
                cookieName="cookiesPermissions"
                style={{ background: '#2B373B' }}
                buttonStyle={{color: '#4e503b', fontSize: '1.2em' }}
                expires={150}
                onAccept={this.handleOnAccept}
            >
                <div className={'message'}>
                    {message} <a href={formatMessage({id: 'url.cookieConsent'})} target="_blank" rel="noopener noreferrer">{moreInformation}, </a>
                    <ManagePermissions/>
                </div>
            </CookieConsent>
        </div>;
    }
}

const mapStateToProps = state => state;

export default withRouter(injectIntl(connect(mapStateToProps)(CookieBanner)));



// WEBPACK FOOTER //
// ./src/components/notifications/CookieBanner.jsx